import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const SourcingPage = lazy(() => import('../pages/sourcing/page'));
const BeltLinkagePage = lazy(() => import('../pages/belt-linkage/page'));
const OverseasServicePage = lazy(() => import('../pages/overseas-service/page'));
const ParkIntroPage = lazy(() => import('../pages/park-intro/page'));
const CrossBorderPage = lazy(() => import('../pages/cross-border/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/sourcing',
    element: <SourcingPage />,
  },
  {
    path: '/belt-linkage',
    element: <BeltLinkagePage />,
  },
  {
    path: '/overseas-service',
    element: <OverseasServicePage />,
  },
  {
    path: '/park-intro',
    element: <ParkIntroPage />,
  },
  {
    path: '/cross-border',
    element: <CrossBorderPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;